import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useIsMobile } from '@/hooks/useIsMobile';

const STORAGE_KEY = 'podbrief_install_banner_dismissed';
const APP_STORE_URL = 'https://apps.apple.com/us/app/podbrief/id6759987252';

export function InstallBanner() {
  const { user, profile } = useAuth();
  const { isMobile, isIOS } = useIsMobile();
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY) === 'true';
    setIsDismissed(dismissed);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsDismissed(true);
  };

  const isSubscribed = profile?.plan === 'pro' || profile?.plan === 'executive';
  const shouldShow = isMobile && user && isSubscribed && !isDismissed;

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="fixed top-16 left-0 right-0 z-40 p-3 bg-card/95 backdrop-blur-lg border-b border-border">
      <div className="flex items-center gap-3 max-w-lg mx-auto">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center">
          <Smartphone className="w-5 h-5 text-primary" />
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">
            {isIOS ? 'Get the PodBrief App' : 'Install PodBrief'}
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {isIOS ? 'Available on the App Store' : 'Add to home screen'}
          </p>
        </div>

        {isIOS ? (
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <Button size="sm" className="flex-shrink-0">
              Get App
            </Button>
          </a>
        ) : (
          <Link to="/install">
            <Button size="sm" className="flex-shrink-0">
              Install
            </Button>
          </Link>
        )}

        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-2 -mr-1 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
